import { Form } from 'react-bootstrap'
import { Modable } from '../../../../components/Modable'
import { useEffect, useState } from 'react'
import { Container, Footer } from './styles'
import { CustomButton } from '../../../../components/CustomButton'
import { CheckCircleFill } from 'react-bootstrap-icons'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'
import CategoriesService from '../../../../services/database/CategoriesService'
import { toast } from 'react-toastify'

export function ModalCreate({ isOpen, onClose, loadCategories }) {
  const [categoryName, setCategoryName] = useState('')
  const [isCreateRequestLoading, setIsCreateRequestLoading] = useState(false)

  async function handleCreateCategory() {
    try {
      setIsCreateRequestLoading(true)

      await CategoriesService.create({ name: categoryName })

      loadCategories()
      toast.success('Categoria criada com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao criar a categoria!')
    } finally {
      setIsCreateRequestLoading(false)
      onClose()
    }
  }

  function resetStates() {
    setCategoryName('')
    setIsCreateRequestLoading(false)
  }

  useEffect(() => {
    resetStates()
  }, [])

  return (
    <Modable
      isOpen={isOpen}
      onClose={onClose}
      size="medium"
    >
      <Container>
        <div>
          <h1>Cadastrar Categoria</h1>

          <Form.Control
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            placeholder="Digite o nome..."
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                if (e.target.value) {
                  handleCreateCategory()
                }
              }
            }}
          />
        </div>

        <Footer>
          <CustomButton
            isDisabled={!categoryName}
            title="Cadastrar"
            color="#0d9a04"
            onClick={handleCreateCategory}
            isLoading={isCreateRequestLoading}
            isLoadingText="Cadastrando..."
          >
            <CheckCircleFill />
          </CustomButton>
        </Footer>
      </Container>
    </Modable>
  )
}
